import { Routes } from '@angular/router';
import { Login } from './components/login/login';
import { Dashboard } from './components/dashboard/dashboard';
import { BinLiveInfoPage } from './components/bin-live-info-page-main/bin-live-info-page/bin-live-info-page';
import { Logout } from './components/logout/logout';
import { AuthService } from './services/auth.service';
import { Workplans } from './components/workplans-page/workplans/workplans';
import { Inventory } from './components/inventory/inventory';
import { Reports } from './components/reports-page/reports/reports';
import { Collections } from './components/reports-page/collections/collections';
import { SiteManagment } from './components/site-managment/site-managment';
import { SiteConfig } from './components/site-managment/site-config/site-config';
import { SwapUnit } from './components/site-managment/swap-unit/swap-unit';
import { InstallNewBin } from './components/site-managment/install-new-bin/install-new-bin';
import { PreMapping } from './components/site-managment/pre-mapping/pre-mapping';
import { FillableBins } from './components/fillable-bins/fillable-bins';
import { NewInstallationWizard } from './components/site-managment/new-installation-wizard/new-installation-wizard';
import { BinsMonitoring } from './components/site-managment/bins-monitoring/bins-monitoring';
import { Fillings } from './components/fillings/fillings';
import { TicketManagement } from './components/ticket-management/ticket-management';
import { Insights } from './components/insights/insights';
import { DriverPlans } from './components/driver-plans/driver-plans';
import { DriverList } from './components/driver-list/driver-list';
import { Billing } from './components/billing/billing';

export const routes: Routes = [
    { path: 'logout', component: Logout },
	{ path: 'login', component: Login },
	{ path: '', redirectTo: 'dashboard', pathMatch: 'full'},
	{ path: 'dashboard', component: Dashboard, canActivate: [AuthService] },
	{ path: 'fillableBins', component: FillableBins, canActivate: [AuthService] },
	{ path: 'workplans', component: Workplans, canActivate: [AuthService] },
	{ path: 'inventory', component: Inventory, canActivate: [AuthService] },
	{ path: 'insights', component: Insights, canActivate: [AuthService] },
	{ path: 'reports', component: Reports, canActivate: [AuthService], data: { blockedRoles: [8] } },
	{ path: 'collections', component: Collections, canActivate: [AuthService] },
	{ path: 'fillings', component: Fillings, canActivate: [AuthService] },
	{ path: 'siteMangment', component: SiteManagment, canActivate: [AuthService] },
	{ path: 'ticketManagement', component: TicketManagement, canActivate: [AuthService] },
	{ path: 'ticketManagement/:id', component: TicketManagement, canActivate: [AuthService] },
	{ path: 'driverplans', component: DriverPlans, canActivate: [AuthService] },
	{ path: 'driverplans/:siteid/:tabletid', component: DriverList, canActivate: [AuthService] },
	{ path: 'siteConfig/:description/:id', component: SiteConfig, canActivate: [AuthService] },
	{ path: 'swapUnit/:description/:id', component: SwapUnit, canActivate: [AuthService]},
	{ path: 'swapUnit/:description/:id/:item', component: SwapUnit, canActivate: [AuthService]},
	{ path: 'binsmonitoring/:id', component: BinsMonitoring, canActivate: [AuthService] },
	{ path: 'installNewBin/:id', component: InstallNewBin, canActivate: [AuthService] },
	{ path: 'preMapping/:description/:id', component: PreMapping, canActivate: [AuthService] },
	{ path: 'newinstallationwizard/:id/:binName', component: NewInstallationWizard, canActivate: [AuthService]},
	{ path: 'binLiveInfoPage', component: BinLiveInfoPage, canActivate: [AuthService] },
	{ path: 'resetPassword/:token', component: Login},
	{ path: 'billing', component: Billing, canActivate: [AuthService], data: { allowedRoles: [2,5] } }
];
